<template>
    <div class="w-full desktop:mx-auto desktop:max-w-[1160px] mt-[20px] inset-0 relative border-1 rounded-[10px] laptop:rounded-[20px] p-[5px] tablet:p-[10px] laptop:p-[20px] bg-opacity-50 bg-[#fff] border-[#CCCCCC]">
        <customAccordion :items="faqData" />
    </div>
</template>
<script>
import customAccordion from '../../components/partialComponent/customAccordion.vue';
export default {
    components: {
        customAccordion,
    },

    data() {
        return {
            faqData : [
                {
                    title: "What is a MyHappyHome Protection Plan?",
                    content: `
                    <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">A MyHappyHome Protection Plan helps cover the cost of repairs or maintenance for eligible home systems and appliances. Each plan includes specific covered items, exclusions, and a maximum coverage amount.</p>
                    `
                },
                {
                    title: "How do I purchase a protection plan?",
                    content: `
                    <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">You can purchase a protection plan directly from our website by selecting the plan that best fits your needs and completing checkout using a credit card.</p>
                    `
                },
                {
                    title: "How do I create a claim?",
                    content: `
                    <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">Once you have an active plan, you can create a claim from your MyHappyHome account. Simply log in, select your plan, and submit a claim for a covered issue.</p>
                    `
                },
                {
                    title: "What does my plan cover?",
                    content: ` <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">Each plan includes a list of <strong>covered items</strong> and <strong>non-covered items</strong>, along with a defined <strong>coverage limit</strong>. Coverage details are clearly shown before purchase and can be viewed anytime in your account.</p>`
                },
                {
                    title: "Is there a coverage limit on claims?",
                    content: ` <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">Yes. Every plan has a maximum coverage amount. Claims are approved up to this limit, based on the terms of your selected plan.</p>`
                },
                {
                    title: "How does payment work?",
                    content: ` 
                    <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">Payments are billed <strong>monthly</strong> to your credit card. Your plan will <strong>auto-renew</strong> each month to ensure uninterrupted coverage.</p>
                    `
                },
                {
                    title: "Can I change my payment method?",
                    content: ` 
                    <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">Yes. You can update or change your <strong>default credit card</strong> anytime from the <strong>Billing</strong> section of your MyHappyHome account.</p>
                    `
                },
                {
                    title: "What happens if my payment fails?",
                    content: ` 
                    <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">If a payment fails, we’ll notify you so you can update your billing information. Coverage may be paused if payment is not successfully completed.</p>
                    `
                },
                {
                    title: "Is there a waiting period before I can create a claim?",
                    content: ` 
                    <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">Yes. There is a <strong>30-day waiting period</strong> after purchasing your protection plan before you can create a claim. This helps ensure coverage is active and in line with plan terms.</p>
                    `
                },
                {
                    title: "How can I delete my account?",
                    content: ` 
                    <p class="!py-[10px] laptop:!py-[20px] font-poppins text-[12px] laptop:text-sm font-normal text-[#333333]">You can delete your MyHappyHome account directly from the <strong>Profile</strong> section of your dashboard. Once deleted, you will no longer be able to access your plans or account details.</p>
                    `
                },
            ]
        };
    },

    computed: {
    },
    mounted() {
        setTimeout(() => {
            document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
        
        }, 500);
    },
}
</script>